export default {
  props: {
    activeView: String,
  },
};
